import { createActionTypes } from 'utils/action/actionTypes';

export const DELETE_ELECTRICITY_BILL = createActionTypes('DELETE_ELECTRICITY_BILL');
export const GET_ELECTRICITY_BILL = createActionTypes('GET_ELECTRICITY_BILL');
export const UPDATE_ELECTRICITY_BILL = createActionTypes('UPDATE_ELECTRICITY_BILL');
export const UPLOAD_ELECTRICITY_BILL = createActionTypes('UPLOAD_ELECTRICITY_BILL');
export const ADD_ELECTRICITY_BILL = createActionTypes('ADD_ELECTRICITY_BILL');
export const DOWNLOAD_ELECTRICITY_BILL = createActionTypes('DOWNLOAD_ELECTRICITY_BILL');
